import SignalListener from "./SignalListener";
var Signal = (function () {
    function Signal() {
        this.listeners = [];
    }
    Signal.prototype.on = function (name, handler, priority, once) {
        this.listeners.push(new SignalListener(name, handler, priority, once));
        this.listeners.sort(function (a, b) {
            return a.priority - b.priority;
        });
    };
    Signal.prototype.off = function (name, handler) {
        var _this = this;
        this.listeners.forEach(function (item) {
            var remove = false;
            if (!handler) {
                if (item.name === name)
                    remove = true;
            }
            else {
                if (item.name === name && item.handler === handler)
                    remove = true;
            }
            if (remove)
                _this.listeners.splice(_this.listeners.indexOf(item), 1);
        });
    };
    Signal.prototype.emit = function (name) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.listeners.forEach(function (item) {
            if (item.name === name) {
                item.handler.apply(item, args);
                if (item.once)
                    _this.listeners.splice(_this.listeners.indexOf(item), 1);
            }
        });
    };
    return Signal;
}());
export default Signal;



//////////////////
// WEBPACK FOOTER
// ./src/utils/signals/Signal.ts
// module id = null
// module chunks = 